import { render, staticRenderFns } from "./ChargeTypeDetails.vue?vue&type=template&id=edf63bea&scoped=true"
import script from "./ChargeTypeDetails.vue?vue&type=script&lang=js"
export * from "./ChargeTypeDetails.vue?vue&type=script&lang=js"
import style0 from "./ChargeTypeDetails.vue?vue&type=style&index=0&id=edf63bea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edf63bea",
  null
  
)

export default component.exports